import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { BehaviorSubject, catchError, filter, finalize, switchMap, take, throwError } from 'rxjs';
import { BasemodelService } from './basemodel.service';
import { CampuscctvserviceService } from './service/campuscctvservice.service';
import { environment } from '../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {

  private isRefreshing = false; // Track refresh status
  private refreshTokenSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);

  constructor(private http: CampuscctvserviceService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    

    const reqPar = request.url.split('/');
      //  ADD THIS — Skip interceptor for Google Input Tools
  if (request.url.includes('inputtools.google.com') || 
      request.url.includes('google-input')) {
    return next.handle(request);  // Pass through WITHOUT token
  }
  // InfinityLearn SCORE OTP / register / profiles — keep IL Bearer token (do not overwrite with app JWT)
  if (
    request.url.includes('infinitylearn.com') ||
    request.url.includes('infinitylearn.in') ||
    request.url.includes('/api/v2/unified/generate-otp') ||
    request.url.includes('/api/v3/generate-otp') ||
    request.url.includes('/api/v1/unified/login-with-otp') ||
    request.url.includes('/api/v1/unified/register') ||
    request.url.includes('/api/v1/unified/profiles')
  ) {
    return next.handle(request);
  }
    console.log(reqPar)
    if (reqPar[4] === 'login' && reqPar[reqPar.length - 1] != 'logOut') {
      return next.handle(request);
    }
    if (reqPar[3] === "anonymouseUser") {
      console.log("without token from interceptor")
      return next.handle(request);
    }
    if (reqPar[4] === "login") {
      return next.handle(request);
    }
    const currentTime = this.getFormattedTime();
    const storedTime = localStorage.getItem("time");
    if (storedTime) {
      const currentTimeDate = this.convertToDate(currentTime);
      const storedTimeDate = this.convertToDate(storedTime);

      if (currentTimeDate < storedTimeDate) {
        return this.handleRequestWithToken(request, next);
      } else {
        return this.handleTokenRefresh(request, next);
      }
    }

    return next.handle(request);
  }

private handleRequestWithToken(
  request: HttpRequest<unknown>,
  next: HttpHandler
): Observable<HttpEvent<unknown>> {

  const token = localStorage.getItem("token");
  if (!token) {
    return next.handle(request);
  }
  let isTicketApi = false;
  try {
    const url = new URL(request.url);
    isTicketApi = url.origin === environment.ticketUrl;

  } catch (e) {
    isTicketApi = request.url.includes(environment.ticketUrl);
  }
  const clonedRequest = request.clone({
    setHeaders: {
      Authorization: isTicketApi ? `Bearer ${token}` : token
    }
  });

  return next.handle(clonedRequest);
}
  private handleTokenRefresh(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null); // Reset token queue

      return this.http.getRefreshToken().pipe(
        switchMap((res: any) => {
          const newToken = res.jsonV2.accessToken;
          localStorage.setItem("token", newToken);
          localStorage.setItem("tokenRefreshKey", res.jsonV2.tokenRefreshKey);
          localStorage.setItem("time", res.jsonV2.tokenValidTime);

          this.isRefreshing = false;
          this.refreshTokenSubject.next(newToken); // Notify all queued requests

          return this.handleRequestWithToken(request, next);
        }),
        catchError((error) => {
          this.isRefreshing = false;
          return throwError(error);
        })
      );
    } else {
      // Queue the request until token refresh completes
      return this.refreshTokenSubject.pipe(
        filter(token => token !== null),
        take(1),
        switchMap(() => this.handleRequestWithToken(request, next))
      );
    }
  }

  getFormattedTime(): string {
    const now = new Date();
    const options: Intl.DateTimeFormatOptions = {
      weekday: 'short',
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      year: 'numeric',
      timeZone: 'Asia/Kolkata', // IST Timezone
      hour12: false, // 24-hour format
    };

    return new Intl.DateTimeFormat('en-US', options)
      .format(now)
      .replace(',', '') // Remove extra comma
      .replace(/(\d{2}):(\d{2}):(\d{2})/, "$1:$2:$3 IST"); // Insert "IST" correctly
  }

  convertToDate(timeStr: string): Date {
    // Remove 'IST' and convert to Date
    const cleanedTimeStr = timeStr.replace(' IST', '');
    const dateObj = new Date(cleanedTimeStr);
    return dateObj;
  }
}


